import { CustomAction, CommonState } from '../model/state';
import { CommonPayload } from '../actions/Common';
import {
  FETCH_USER_LIST, FETCH_USER_LIST_SUCCESS, FETCH_USER_LIST_ERROR, SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_ERROR,
  OPEN_CONFIRMATION_DIALOG, CLOSE_CONFIRMATION_DIALOG, CREATE_USER, CREATE_USER_SUCCESS, CREATE_USER_ERROR,
  ACCEPT_INVITATION, ACCEPT_INVITATION_SUCCESS, ACCEPT_INVITATION_ERROR, FETCH_LOCATIONS_ERROR, FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS, EDIT_USER_ROLES, EDIT_USER_ROLES_SUCCESS, EDIT_USER_ROLES_ERROR, FETCH_COUNTRY_LIST_SUCCESS,
  FETCH_REGION_LIST_SUCCESS, FETCH_TIMEZONE_LIST_SUCCESS, CREATE_LOCATION, CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_ERROR, REMOVE_LOCATIONS, REMOVE_LOCATIONS_SUCCESS, REMOVE_LOCATIONS_ERROR,
  FETCH_USER_LOCATIONS_ROLES_SUCCESS, FETCH_USER_LOCATIONS_ROLES, FETCH_USER_LOCATIONS_ROLES_ERROR,
  ASSIGN_USER_LOCATION_ROLES, ASSIGN_USER_LOCATION_ROLES_SUCCESS, ASSIGN_USER_LOCATION_ROLES_ERROR,
  FETCH_ALERTS_BY_USER, FETCH_ALERTS_BY_USER_SUCCESS, FETCH_ALERTS_BY_USER_ERROR, EDIT_LOCATION, EDIT_LOCATION_SUCCESS,
  EDIT_LOCATION_ERROR, FETCH_COUNTRY_LIST, FETCH_REGION_LIST, FETCH_TIMEZONE_LIST, RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR, OPEN_TEXT_CONFIRMATION_MODAL, CLOSE_TEXT_CONFIRMATION_MODAL,
  DISABLE_API_CACHE, ENABLE_API_CACHE, OPEN_RENAME_DEVICE_MODAL, CLOSE_RENAME_DEVICE_MODAL,
  CREATE_BULK_UNITS_REQUEST, CREATE_BULK_UNITS_SUCCESS, CREATE_BULK_UNITS_ERROR, RESEND_USER_INVITE_ERROR, RESEND_USER_INVITE_SUCCESS, REVOKE_USER_INVITE, REVOKE_USER_INVITE_ERROR, REVOKE_USER_INVITE_SUCCESS,
} from 'constants/ActionTypes';
import { AlertPayload, LocationPayload } from 'actions';

const initialState: CommonState = {
  isContentLoading: false,
  isSubmitting: false,
  confirmationDialog: {
    isOpen: false,
    metadata: {}
  },
  textConfirmationModal: {
    isOpen: false,
    metadata: {}
  },
  renameDeviceModal: {
    isOpen: false,
    metadata: {}
  },
  countries: undefined,
  regions: undefined,
  timezones: undefined,
  apiCacheDisabled: false,
};

function commonReducer(state: CommonState | undefined = initialState, action: CustomAction<CommonPayload & AlertPayload & LocationPayload>) {
  switch (action.type) {

    case FETCH_USER_LIST:
      return { ...state, isContentLoading: true };

    case FETCH_LOCATIONS_SUCCESS:
    case FETCH_LOCATIONS_ERROR:
    case FETCH_USER_LIST_SUCCESS:
    case FETCH_USER_LIST_ERROR:
    case FETCH_USER_LOCATIONS_ROLES_SUCCESS:
    case FETCH_USER_LOCATIONS_ROLES_ERROR:
    case FETCH_ALERTS_BY_USER_SUCCESS:
    case FETCH_ALERTS_BY_USER_ERROR:
      return { ...state, isContentLoading: false };

    case FETCH_ALERTS_BY_USER:
      return { ...state, isContentLoading: action.payload?.filter?.page === 1 };

    case FETCH_LOCATIONS:
    case FETCH_USER_LOCATIONS_ROLES:
      return { ...state, isContentLoading: action.payload?.page === 1 };

    case SAVE_USER:
    case CREATE_USER:
    case REVOKE_USER_INVITE:
    case ACCEPT_INVITATION:
    case EDIT_USER_ROLES:
    case CREATE_LOCATION:
    case EDIT_LOCATION:
    case REMOVE_LOCATIONS:
    case ASSIGN_USER_LOCATION_ROLES:
    case RESET_PASSWORD:
    case CREATE_BULK_UNITS_REQUEST:
      return { ...state, isSubmitting: true };

    case SAVE_USER_SUCCESS:
    case SAVE_USER_ERROR:
    case CREATE_USER_SUCCESS:
    case CREATE_USER_ERROR:
    case ACCEPT_INVITATION_SUCCESS:
    case ACCEPT_INVITATION_ERROR:
    case EDIT_USER_ROLES_SUCCESS:
    case EDIT_USER_ROLES_ERROR:
    case CREATE_LOCATION_SUCCESS:
    case RESEND_USER_INVITE_SUCCESS:
    case RESEND_USER_INVITE_ERROR:
    case REVOKE_USER_INVITE_SUCCESS:
    case REVOKE_USER_INVITE_ERROR:
    case CREATE_LOCATION_ERROR:
    case EDIT_LOCATION_SUCCESS:
    case EDIT_LOCATION_ERROR:
    case REMOVE_LOCATIONS_SUCCESS:
    case REMOVE_LOCATIONS_ERROR:
    case ASSIGN_USER_LOCATION_ROLES_SUCCESS:
    case ASSIGN_USER_LOCATION_ROLES_ERROR:
    case RESET_PASSWORD_SUCCESS:
    case RESET_PASSWORD_ERROR:
    case CREATE_BULK_UNITS_SUCCESS:
    case CREATE_BULK_UNITS_ERROR:
      return { ...state, isSubmitting: false };

    case OPEN_CONFIRMATION_DIALOG:
      return {
        ...state, confirmationDialog: {
          ...state.confirmationDialog,
          isOpen: true,
          metadata: action.payload?.metadata || {}
        }
      };

    case CLOSE_CONFIRMATION_DIALOG:
      return { ...state, confirmationDialog: initialState.confirmationDialog };

    case OPEN_TEXT_CONFIRMATION_MODAL:
      return {
        ...state,
        textConfirmationModal: {
          ...state.textConfirmationModal,
          isOpen: true,
          metadata: action.payload?.metadata || {}
        }};

    case CLOSE_TEXT_CONFIRMATION_MODAL:
      return { ...state, textConfirmationModal: initialState.textConfirmationModal };

    case OPEN_RENAME_DEVICE_MODAL:
      return {
        ...state,
        renameDeviceModal: {
          ...state.renameDeviceModal,
          isOpen: true,
          metadata: action.payload?.metadata || {}
        }};

    case CLOSE_RENAME_DEVICE_MODAL:
      return { ...state, renameDeviceModal: initialState.renameDeviceModal };


    case FETCH_COUNTRY_LIST: {
      return { ...state, countries: undefined }
    }

    case FETCH_COUNTRY_LIST_SUCCESS: {
      return { ...state, countries: action.payload?.countries || [] }
    }

    case FETCH_REGION_LIST: {
      return { ...state, regions: undefined }
    }

    case FETCH_REGION_LIST_SUCCESS: {
      return { ...state, regions: action.payload?.regions || [] }
    }

    case FETCH_TIMEZONE_LIST: {
      return { ...state, timezones: undefined }
    }

    case FETCH_TIMEZONE_LIST_SUCCESS: {
      return { ...state, timezones: action.payload?.timezones || [] }
    }

    case DISABLE_API_CACHE: {
      return { ...state, apiCacheDisabled: true };
    }

    case ENABLE_API_CACHE: {
      return { ...state, apiCacheDisabled: false };
    }

    default:
      return state
  }
}

export default commonReducer;
